'use client';

import { useState, useEffect } from 'react';

const pacificFormatter = new Intl.DateTimeFormat('en-US', {
  timeZone: 'America/Los_Angeles',
  month: 'short',
  day: 'numeric',
  year: 'numeric',
  hour: 'numeric',
  minute: '2-digit',
});

function formatTimeAgo(dateStr: string): string {
  const then = new Date(dateStr).getTime();
  const diffMs = Date.now() - then;
  const diffMins = Math.floor(diffMs / 60000);

  if (diffMins < 1) return 'just now';
  if (diffMins < 60) return `${diffMins} min ago`;
  return pacificFormatter.format(then) + ' PT';
}

export default function TimeAgo({ date }: { date: string }) {
  const [display, setDisplay] = useState(() => formatTimeAgo(date));

  useEffect(() => {
    setDisplay(formatTimeAgo(date));
    const id = setInterval(() => setDisplay(formatTimeAgo(date)), 30_000);
    return () => clearInterval(id);
  }, [date]);

  return <time dateTime={date}>{display}</time>;
}
